import React, { Fragment } from 'react';

export default {
  units: [
    {
      id: 'C1',
      mockup: (
        <g id="c1" transform="translate(186.000000, 186.000000)">
          <polygon
            id="fill-c1"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="85.2215388 89.9181684 75.1620118 89.9181684 75.1620118 71.7551335 55.7324219 71.7551335 55.7324219 0.685546875 18.3920898 0.685546875 0.770507812 126.397949 13.3305664 126.397949 13.3305664 149.828613 13.9726562 149.828613 13.9726562 152.065918 106.588379 152.065918 106.588379 89.9181684"
          />
          <text
            id="01"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="38.54422" y="98.9453409">
              01
            </tspan>
          </text>
          <text
            id="C1"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="38.07822" y="114.945341">
              C1
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B7',
      mockup: (
        <g id="b7" transform="translate(179.000000, 335.000000)">
          <path
            d="M17.3339488,73.4617512 C17.3339488,75.138339 17.3339488,76.8149269 17.3339488,78.4915147 L67.3521526,78.4915147 L67.3521526,59.1176108 L108.940845,59.1176108 L108.940845,54.8329975 L108.940845,37.6650391 L113.725586,37.6650391 L113.725586,3.13671875 L20.9755859,3.13671875 L20.9755859,0.908203125 L0.213867188,0.908203125 L0.213867188,48.1552734 L6.67675781,48.1552734 L6.67675781,46.1601562 L17.3339488,46.1601562 C17.3339488,62.6846317 17.3339488,71.7851634 17.3339488,73.4617512 Z"
            id="fill-b7"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <text
            id="11"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="45.04422" y="28.8158246">
              11
            </tspan>
          </text>
          <text
            id="B7"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="45.04422" y="44.8158246">
              B7
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'C2',
      mockup: (
        <g id="c2" transform="translate(179.000000, 389.000000)">
          <polygon
            id="fill-c2"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="107.590261 115.213545 107.590261 66.8719295 107.031398 66.8719295 107.031398 21.8834892 137.768842 21.8834892 137.768842 10.1473743 123.734375 10.1473743 123.734375 0.74609375 109.269531 0.74609375 109.269531 4.91699219 67.6240234 4.91699219 67.6240234 24.3027344 17.4980469 24.7617188 17.4980469 20.0009766 0.456054688 20.0009766 0.456054688 60.5078125 20.8486328 60.5078125 20.8486328 69.0791016 24.75 69.0791016 24.75 80.6103516 20.8486328 80.6103516 20.8486328 91.9814453 24.75 91.9814453 24.75 108.363281 23.1640625 108.363281 23.1640625 115.213545"
          />
          <text
            id="10"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="51.0505586" y="57.0927683">
              10
            </tspan>
          </text>
          <text
            id="C2"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="50.4805586" y="73.9440173">
              C2
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B6',
      mockup: (
        <g id="b6" transform="translate(286.000000, 389.000000)">
          <polygon
            id="fill-b6"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="72.4041063 0.832997476 72.4041063 89.3195777 32.6708984 89.3195777 32.6708984 108.045898 34.6826172 108.045898 34.6826172 115.149414 0.654296875 115.149414 0.654296875 66.9573975 0.0236816406 66.9573975 0.0236816406 21.8833008 30.6918945 21.8833008 30.6918945 9.89257812 43.7412109 9.89257812 43.7412109 0.832997476"
          />
          <text
            id="09"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="31.2546243" y="48.1347683">
              09
            </tspan>
          </text>
          <text
            id="B6"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="31.2546243" y="63.7664407">
              B6
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B5',
      mockup: (
        <g id="b5" transform="translate(358.000000, 389.000000)">
          <polygon
            id="fill-b5"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="84.7923607 19.4617512 44.2748213 19.4617512 44.2748213 7.35306128 16.3316907 7.35306128 16.3316907 0.832997476 0.454101562 0.832997476 0.454101562 89.3525391 69.7797852 89.3525391"
          />
          <text
            id="08"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="29.99539" y="46.9151917">
              08
            </tspan>
          </text>
          <text
            id="B5"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="28.99539" y="62.9151917">
              B5
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'A2',
      mockup: (
        <g id="a2" transform="translate(372.000000, 342.000000)">
          <path
            d="M92.02914,0.702250521 L0.0962402954,0.702250521 L0.0962402954,30.5161133 L2.51806641,30.5161133 C1.96468099,46.3881836 1.96468099,54.3242187 2.51806641,54.3242187 C3.07145182,54.3242187 12.3058268,54.3242187 30.2211914,54.3242187 L30.2211914,66.5170898 L70.6621094,66.5170898 L76.7602539,38.5737305 L86.8642578,38.5737305 L86.8642578,40.206543 L92.02914,40.206543 L92.02914,0.702250521 Z"
            id="fill-a2"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <text
            id="07"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="36.8665306" y="25.7423781">
              07
            </tspan>
          </text>
          <text
            id="A2"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="36.3145306" y="41.7423781">
              A2
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'A1',
      mockup: (
        <g id="a1" transform="translate(372.000000, 286.000000)">
          <polygon
            id="fill-a1"
            stroke="#000000"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="83.9256321 3.05143976 83.9256321 0.81598931 0.0962402954 0.81598931 0.0962402954 56.7197266 92.105957 56.7197266 92.105957 27.9814453 83.9256321 27.9814453"
          />
          <text
            id="06"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="35.8665306" y="25.5">
              06
            </tspan>
          </text>
          <text
            id="A1"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="35.3145306" y="41.5">
              A1
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B2',
      mockup: (
        <g id="b2" transform="translate(293.000000, 156.000000)">
          <polygon
            id="fill-b2"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="5.41951927 18.7640356 0.0171806815 18.7640356 0.0171806815 100.078546 40.5 100.078546 40.5 80.8618164 68.0073242 80.8618164 68.0073242 0.216308594 28.9018555 0.216308594 28.9018555 6.95654297 30.4707031 6.95654297 30.4707031 18.7640356"
          />
          <text
            id="03"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="22.9595412" y="47.0075684">
              03
            </tspan>
          </text>
          <text
            id="B2"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="22.1795412" y="63.0075684">
              B2
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B1',
      mockup: (
        <g id="b1" transform="translate(238.000000, 156.000000)">
          <polygon
            id="fill-b1"
            stroke="#0B1A27"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="60.2539062 18.9379883 60.2539062 0.384765625 0.569335938 0.384765625 0.569335938 7.17529297 2.08691406 7.17529297 2.08691406 30.7036133 3.61230469 30.7036133 3.61230469 101.630371 32.9716797 101.630371 32.9716797 99.7045898 54.7797852 99.7045898 54.7797852 18.9379883"
          />
          <text
            id="02"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="21.9116211" y="48.6576711">
              02
            </tspan>
          </text>
          <text
            id="B1"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="20.9116211" y="64.6576711">
              B1
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B3',
      mockup: (
        <g id="b3" transform="translate(348.000000, 156.000000)">
          <polygon
            id="Shape"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="115.266564 54.0803227 59.7232805 54.0803227 59.7232805 76.9675047 40.1854423 76.9675047 40.1854423 99.7290039 0.978027344 99.7290039 0.978027344 81.0053711 12.625 81.0053711 12.625 0.419921875 56.0307617 0.419921875 56.0307617 7.06591797 54.6542969 7.06591797 54.6542969 18.262207 109.064941 18.262207 109.064941 16.7192383 116.369629 16.7192383 116.369629 25.1455078 114.29834 25.1455078 114.29834 44.9584961 115.266564 44.9584961"
          />
          <text
            id="04"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="33.9197194" y="44.7640356">
              04
            </tspan>
          </text>
          <text
            id="B3"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="33.1397194" y="60.7640356">
              B3
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B4',
      mockup: (
        <g id="b4" transform="translate(372.000000, 210.000000)">
          <polygon
            id="Path-3"
            stroke="#0B1A27"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="3.85693359 45.6513672 15.9775391 45.6513672 15.9775391 23.2700195 35.402832 23.2700195 35.402832 0.258300781 91.7578125 0.258300781 91.7578125 5.58740234 90.3242188 5.58740234 90.3242188 25.7802734 91.7578125 25.7802734 91.7578125 35.9492187 84.0239258 35.9492187 84.0239258 58.3125 91.7578125 58.3125 91.7578125 79.0625 84.0239258 79.0625 84.0239258 76.9433594 0.078125 76.9433594 0.078125 65.8066406 3.85693359 65.8066406"
          />
          <text
            id="05"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="40.104" y="41.7290039">
              05
            </tspan>
          </text>
          <text
            id="B4"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="39.324" y="57.7290039">
              B4
            </tspan>
          </text>
        </g>
      ),
    },
  ],
  outline: (
    <Fragment>
      <text
        id="AMENITY-TERRACE"
        fontFamily="DINOT, DIN OT"
        fontSize="10"
        fontWeight="normal"
        fill="#0B1A27"
      >
        <tspan x="488.801869" y="190.764036">
          AMENITY{' '}
        </tspan>
        <tspan x="487.876869" y="202.764036">
          TERRACE
        </tspan>
      </text>
      <text
        id="LEVEL-6-–-13"
        fontFamily="DINCanfor-Medium, DIN Canfor"
        fontSize="16"
        fontWeight="400"
        fill="#0B1A27"
      >
        <tspan x="287.34" y="597.839844">
          LEVEL 6 – 13
        </tspan>
      </text>
      <g
        id="bg-shapes"
        transform="translate(163.000000, 132.000000)"
        stroke="#0B1A27"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      >
        <polygon
          id="Shape"
          points="292.925632 154.815989 292.925632 181.920826 301.02914 181.920826 301.02914 210.702251 209.09624 210.702251 209.09624 154.815989"
        />
        <rect
          id="Rectangle-path"
          x="160.754624"
          y="143.918168"
          width="25.4282489"
          height="96.6832319"
        />
        <path
          d="M160.754624,175.214475 L186.182873,175.214475 M160.754624,208.187369 L186.182873,208.187369"
          id="Shape"
        />
        <path
          d="M145.665334,219.08519 L145.665334,167.110967 M130.017181,219.08519 L160.754624,219.08519 M130.017181,167.110967 L160.754624,167.110967"
          id="Shape"
        />
        <path
          d="M186.182873,240.6014 L160.754624,208.001081 L186.182873,175.028187 L160.754624,143.731881 M160.754624,240.415113 L186.182873,207.814794 L160.754624,174.8419 L186.182873,143.545593"
          id="Shape"
        />
        <polyline
          id="Path"
          points="139.238414 257.832997 139.238414 267.147374 166.855541 267.147374 166.855541 257.832997"
        />
        <polyline
          id="Path"
          points="36.6871245 203.716468 36.6871245 205.951918 129.598034 205.951918"
        />
        <polyline
          id="Path"
          points="129.598034 240.6014 124.428555 240.6014 124.428555 257.832997 211.331691 257.832997 211.331691 240.6014 209.09624 240.6014 209.09624 143.918168 213.008279 143.918168 213.008279 124.078546 108.221539 124.078546 108.221539 143.918168 129.598034 143.918168"
        />
        <polyline
          id="Path"
          points="160.614909 143.918168 129.598034 143.918168 129.598034 240.6014 160.614909 240.6014"
        />
        <polyline
          id="Path"
          points="157.122017 372.213545 197.080694 372.213545 197.080694 346.319578"
        />
        <polyline
          id="Path"
          points="301.02914 249.915777 301.02914 279.814927 279.233498 279.814927"
        />
        <polyline
          id="Path"
          points="301.02914 154.909133 316.118431 154.909133 316.118431 183.969989 301.02914 183.969989"
        />
        <polyline
          id="Path"
          points="292.599629 129.667172 400.13411 129.667172 400.13411 0.15234375"
        />
        <polyline
          id="Path"
          points="238.99539 24.3215694 238.99539 19.0123746 251.569799 19.0123746 251.569799 0.383620829 400.13411 0.383620829"
        />
        <polyline
          id="Path"
          points="133.370356 24.1352818 133.370356 17.8946493 161.034056 17.8946493 161.034056 24.3215694"
        />
        <polyline
          id="Path"
          points="75.528076 24.3215694 55.0830188 24.3215694 55.0830188 54.7795817"
        />
        <polyline
          id="Path"
          points="15.9626359 203.809612 15.9626359 176.891062 24.3455751 176.891062"
        />
        <polyline
          id="Path"
          points="16.0092078 278.604058 0.0816233653 278.604058 0.0816233653 248.984339 16.0092078 248.984339"
        />
        <polygon
          id="Shape"
          points="22.4361278 372.213545 16.0092078 372.213545 16.0092078 365.553766 19.3623835 365.553766 19.3623835 368.86037 22.4361278 368.86037"
        />
        <path d="M16.0092078,365.507194 L16.0092078,317.724441" id="Shape" />
        <path d="M22.4361278,372.213545 L38.6431436,372.213545" id="Shape" />
        <path
          d="M186.462305,104.797786 L170.255289,104.797786 L170.255289,124.078546 M197.918988,24.3215694 L197.918988,104.797786 L186.462305,104.797786 L186.462305,124.078546"
          id="Shape"
        />
      </g>
      <g
        id="compass"
        transform="translate(563.051950, 473.966278)"
        fill="#0B1A27"
        fillRule="nonzero"
      >
        <polygon
          id="Shape"
          points="10.332078 38.8487477 3.78150781 29.9369255 3.78150781 38.8487477 0.848985112 38.8487477 0.848985112 25.1382519 3.85767723 25.1382519 10.2178239 33.7834812 10.2178239 25.1382519 13.1503466 25.1382519 13.1503466 38.8487477"
        />
        <polygon
          id="Shape"
          points="11.8935511 13.0653988 7.01870819 4.26783067 2.10578055 13.0653988 0.468138008 12.113281 7.01870819 0.345105502 13.5311937 12.113281"
        />
        <rect
          id="Rectangle-path"
          x="6.06659043"
          y="2.32551044"
          width="1.90423552"
          height="21.1370143"
        />
      </g>
    </Fragment>
  ),
};



// WEBPACK FOOTER //
// ./src/data/floorplates/svg/level6-13.js